import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import DegreeService from "../../../Services/Degree.service";
import DegreeLookupModal from "./DegreeLookupModal";
const makeSearchArgs = {
    loadOptions: (search, options) => DegreeService.search(Object.assign(Object.assign({}, options), { query: search, active: true })).then(({ data }) => data),
    label: "fullName",
    value: "id",
};
export const DegreeSearch = makeSearch(makeSearchArgs);
export const DegreeMultiSearch = makeMultiSearch(Object.assign(Object.assign({}, makeSearchArgs), { lookupModal: DegreeLookupModal }));
